import {useMemo} from 'react'
import { useSelector } from 'react-redux';

import {
    isFeatureEnabled,
    isNewPlan21,
    availableFeaturesSelector,
    currentPlanDetailsSelector,
} from 'h-commons';

export const usePlanHook = () => {

    const availableFeatures = useSelector(availableFeaturesSelector);
    const planDetails = useSelector(currentPlanDetailsSelector);

    const is22Plans = () => {
        return [ "Lite_22", "Pro_22", "Elite_22"].includes(planDetails.name);
    }

    const isProAnElitePlanOf22 = () => {
        return  [ "Pro_22", "Elite_22" ].includes(planDetails.name);
    }

    const {newPlan21, pricingRevamp, pricingRevamp22, pricingRevamp23} = useMemo(() => {
        return {
            newPlan21 : isNewPlan21(planDetails),
            pricingRevamp : isFeatureEnabled(availableFeatures, 'pricing-revamp-2021'),
            pricingRevamp22 : isFeatureEnabled(availableFeatures, 'pricing-revamp-2022'),
            pricingRevamp23 : isFeatureEnabled(availableFeatures, 'pricing-revamp-2023'),
        }
    }, [availableFeatures, planDetails])

    return {
        isNewPlan21: newPlan21,
        pricingRevamp22,
        pricingRevamp23,
        pricingRevamp,
        is22Plans,
        isProAnElitePlanOf22,
        planDetails,
    }
}